/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  NO_DATA,
  API_TIMEOUT_ERROR,
} from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_CMS,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_CMS,
  detailScrData: data,
});

//disptach flag for popup
export const dispatchFlag = (data) => ({
  type: actionTypes.DISPATCH_FLAG,
  payload: data,
});
// dispatch Quarter From

export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_CMS,
  payload: data,
});

// select option dispatch
export const getSelectedOption = (data) => ({
  type: actionTypes.SELECT_OPTION,
  payload: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_CMS,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgCMS = (data) => ({
  type: actionTypes.GET_ERROR_MSG_CMS,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgCMS([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgCMS([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// refresh data
export const refreshCMSQuarterlyReporting = () => ({
  type: actionTypes.SET_REFRESH_DATA_CMS,
  payload: {},
});
export const refreshCMSQuarterlyReportingDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_CMS_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjQuarterlyReporting = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_CMS,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_CMS,
  payload: data,
});
// on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_CMS,
  payload: data,
});

//  get rebate programe function
export const getRebateProgramLists = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// dispatch cms rebate group
export const dispatchCmsRebateGroup = (data) => ({
  type: actionTypes.GET_CMS_REBATE_GROUP,
  payload: data,
});
export const getCmsRebateGroup = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.LIST_CMS_REPORT_GROUPS}?utilQtr=${value.utilQtr}`)
    .then((response) => {
      return dispatch(dispatchCmsRebateGroup(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCmsRebateGroup([]));
    });
};
export const dispatchCmsRebateGroupFindFreezeQtr = (data) => ({
  type: actionTypes.GET_CMS_REBATE_GROUP_FREEZE_QTR,
  payload: data,
});
export const getCmsRebateGroupFindFreezeQtrByRpc = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.FIND_FREEZE_QTR_BY_RPC, value)
    .then((response) => {
      return dispatch(dispatchCmsRebateGroupFindFreezeQtr(response.data));
    })
    .catch(() => {
      dispatch(dispatchCmsRebateGroupFindFreezeQtr(null));
    });
};
export const getMaxQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_MAX_QTR_ENROLL, value)
    .then((response) => {
      // Use the quarter string directly from API
      const maxQtr = response.data?.data?.maxFrozenQtrDisplay || '';

      return dispatch({
        type: actionTypes.SET_MAX_QTR_ONLOAD,
        payload: maxQtr,
      });
    })
    .catch(() => {
      dispatch({
        type: actionTypes.SET_MAX_QTR_ONLOAD,
        payload: '',
      });
    });
};


export const dispatchCmsRebateGroupName = (data) => ({
  type: actionTypes.GET_CMS_REBATE_GROUP_NAME,
  payload: data,
});
// dispatch cms rebate group list
export const dispatchCmsRebateGroupList = (data) => ({
  type: actionTypes.GET_CMS_LIST_REBATE_GROUP,
  payload: data,
});
export const getCmsRebateGroupListData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.LIST_CMS_REBATE_PROGRAM, value)
    .then((response) => {
      return dispatch(dispatchCmsRebateGroupList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCmsRebateGroupList([]));
    });
};
export const dispatchCmsRebateGroupNameList = (data) => ({
  type: actionTypes.GET_CMS_LIST_REBATE_GROUP_NAME,
  payload: data,
});
// cms reporting quarterly
export const dispatchCmsReporting = (data) => ({
  type: actionTypes.SET_CMS_QUARTERLY_REPORTING,
  payload: data,
});
export const getCmsReportingData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTERLY_REPORTING, value)
    .then((response) => {
      if (response.data.column1.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchCmsReporting(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchCmsReporting([]));
      // setTimeout(() => {
      //   dispatch(dispatchErrorMsgCMS([]));
      // }, 5000);
      dispatch(
        dispatchErrorMsgCMS([
          {
            field: 'noData',
            message: API_TIMEOUT_ERROR,
          },
        ])
      );
    });
};
// agency info

export const dispatchAgencyInfo = (data) => ({
  type: actionTypes.SET_AGENCY_INFO,
  payload: data,
});
export const getAgencyInfo = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SUBSTANCE_ABUSE_INFO, value)
    .then((response) => {
      return dispatch(dispatchAgencyInfo(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAgencyInfo([]));
    });
};
export const getFreezeCMSQtrPrtBal = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_FREEZE_CMS_QTR_RPT_BALANCE, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return 'failed';
    });
};
export const clearReduxDataOnCMSQtrReport = (payload) => {
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    (payload === '/CMSQuarterlyReporting' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/DisplayCMSQuarterlyReporting';
      }).length > 0) ||
    (payload === '/DisplayCMSQuarterlyReporting' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/CMSQuarterlyReporting';
      }).length > 0)
  ) {
    return {
      type: actionTypes.RESET_CMS_QUARTERLY_REPORTING,
      payload,
    };
  }
  return null;
};
export const dispatchCmsRptAdjSingleRpcQtr = (data) => ({
  type: actionTypes.SET_CMS_RPT_ADJ_SINGLE_RPC_QTR,
  payload: data,
});
export const dispatchCmsRptGrpRpcQtr = (data) => ({
  type: actionTypes.SET_CMS_RPT_GRP_RPC_QTR,
  payload: data,
});


export const getCMSRptAdjSingleRpcQtr = (value) => async (dispatch) => {
  try {
    const response = await axios.post(serviceEndPoint.CMS_RPT_ADJ_RPT_SGL_QTR, value);
    let data = response.data?.data;

    if (!data || (Array.isArray(data) && data.length === 0)) {
      // Fallback to getMaxQtr if no data
      await dispatch(getMaxQtr(value));
      dispatch(dispatchCmsRptAdjSingleRpcQtr([]));
      return '';
    }

    // If response contains a quarter string like "2Q2025", increment it
    if (typeof data === 'string' && data.includes('Q')) {
      const [qtr, year] = data.split('Q');
      let q = parseInt(qtr, 10);
      let y = parseInt(year, 10);

      if (q === 4) {
        q = 1;
        y += 1;
      } else {
        q += 1;
      }

      data = `${q}Q${y}`;
    }

    // Store the incremented quarter in Redux
    dispatch(dispatchCmsRptAdjSingleRpcQtr(data));
    return data;
  } catch {
    await dispatch(getMaxQtr(value));
    dispatch(dispatchCmsRptAdjSingleRpcQtr([]));
    return '';
  }
};

export const getCMSRptGrpRpcQtr = (value) => async (dispatch) => {
  try {
    const response = await axios.post(serviceEndPoint.CMS_RPT_ADJ_RPT_GRP_QTR, value);
    let data = response.data?.data;

    if (!data || (Array.isArray(data) && data.length === 0)) {
      await dispatch(getMaxQtr(value));
      dispatch(dispatchCmsRptGrpRpcQtr([]));
      return '';
    }

    // If response contains a quarter string like "3Q2025", increment it
    if (typeof data === 'string' && data.includes('Q')) {
      const [qtr, year] = data.split('Q');
      let q = parseInt(qtr, 10);
      let y = parseInt(year, 10);

      if (q === 4) {
        q = 1;
        y += 1;
      } else {
        q += 1;
      }

      data = `${q}Q${y}`;
    }

    dispatch(dispatchCmsRptGrpRpcQtr(data));
    return data;
  } catch {
    await dispatch(getMaxQtr(value));
    dispatch(dispatchCmsRptGrpRpcQtr([]));
    return '';
  }
};


